import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'indTitularPipe',
    pure: true
})

export class IndTitularPipe implements PipeTransform {

    transform(cpfTitular: string | undefined, args?: any): any {

        let valor: string = '';

        if (cpfTitular) {
            valor = 'NÃO';
        } else {
            valor = 'SIM';
        }

        return valor;
    }

}
